import React, { useContext, useState, useEffect, useRef } from "react";
import { serializeObject, callApi, isEmpty } from "bodycodi/cmap/app/js/common";

import { DispatchContext, StateContext } from "bodycodi/cmap/app/components/common/context";
import CustomDialog from "bodycodi/cmap/app/components/common/customDialog";
import PopupHeader from "bodycodi/cmap/app/components/common/popupHeader";
import { InputCertify, InputBtn } from "bodycodi/cmap/app/components/cmap1010/input";
import Time from "bodycodi/cmap/app/components/cmap1010/timer";
import FindEmailCompletePop from "./findEmailComplete";
import NameInput from "./NameInput";

const FindEmailPopWrap = () => {
  const { state } = useContext(StateContext);
  const { dispatch } = useContext(DispatchContext);

  const handleClose = () => {
    dispatch({ type: "POP_UP_OPEN", id: "FIND_EMAIL_POP", open: { findEmailPop: false } });
  };

  return (
    <>
      <CustomDialog open={state.findEmailPop} onClose={handleClose}>
        <PopupHeader title="이메일 아이디 찾기" onClickBack={handleClose} />
        <div className="popup-body find-email-pop">
          {state.findEmailPop && (
            <>
              <FindEmailPop />
            </>
          )}
        </div>
      </CustomDialog>
    </>
  );
};

const FindEmailPop = () => {
  const { dispatch } = useContext(DispatchContext);
  const [seqMemberPhoneAuth, setSeqMemberPhoneAuth] = useState("");
  const [timer, setTimer] = useState({
    timerStart: false,
    timerEnd: false,
    refresh: 0,
    stop: false,
  });
  const { timerStart, refresh, timerEnd } = timer;
  const [deviceCrtf, setDeviceCrtf] = useState(false);
  const [mobile, setMobile] = useState("");
  const [name, setName] = useState<string>("");
  const [emailVO, setEmailVO] = useState({});
  const inputMobile = useRef<HTMLInputElement>(null);
  const inputMobile1 = useRef<HTMLInputElement>(null);
  const inputName = useRef<HTMLInputElement>(null);
  const btn = useRef<HTMLDivElement>(null);
  const [succesText, setSuccesText] = useState("");

  useEffect(() => {
    const btn = document.querySelector(".find-email-pop .btn") as HTMLDivElement;
    if (timerEnd) {
      if (btn) {
        if (!deviceCrtf) {
          btn.classList.add("disable");
        }
      }
    } else {
      if (btn) {
        btn.classList.remove("disable");
      }
    }
  }, [timerEnd]);

  useEffect(() => {
    if (deviceCrtf) {
      if (btn.current) {
        btn.current.classList.add("active1");
      }
    } else {
      if (btn.current) {
        btn.current.classList.remove("active1");
      }
    }
  }, [deviceCrtf]);

  useEffect(() => {
    setDeviceCrtf(false);
    if (inputMobile.current) {
      inputMobile.current!.value = "";
    }
  }, [mobile]);

  useEffect(() => {
    if (deviceCrtf) {
      setSuccesText("인증되었습니다.");
    } else {
      setSuccesText("");
    }
  }, [deviceCrtf]);

  const setTimerEnd = (bool: boolean) => {
    setTimer({ ...timer, timerEnd: bool });
  };

  const onblur = (e: any) => {
    setMobile(e.currentTarget.value);
  };
  const openAlert = (msgCtnt: string, header: string) => {
    dispatch({
      type: "ALERT_SETTING",
      data: {
        header: header,
        cancleYn: false,
        redYn: false,
        body: msgCtnt,
        cancelAlert: () => {},
        closeAlert: () => {},
        alert: true,
      },
    });
  };

  const makeReadOnly = () => {
    inputMobile1.current!.readOnly = true;
    // inputName.current!.readOnly = true;
  };

  const sendCrtfcation = () => {
    const data: any = serializeObject({ selector: ".find-email-pop", element: null });
    if (isEmpty(data.mobile)) {
      openAlert("휴대폰 번호를 입력해 주세요.", "비밀번호 찾기");
      return;
    } else if (isEmpty(data.name)) {
      openAlert("이름을 입력해주세요.", "비밀번호 찾기");
      return;
    }
    if (inputMobile.current) {
      inputMobile.current.value = "";
      inputMobile.current.focus();
    }
    setMobile(data.mobile);
    callApi("/mobile/lost/id/certification", { mobile: data.mobile, name: data.name }, "POST").then(
      (res) => {
        const msgVO = res.MsgVO || {};
        const seqMemberPhoneAuth = res.seqMemberPhoneAuth;
        if (msgVO?.msgCd === "CMAP1010-02") {
          openAlert(msgVO.msgCtnt, "휴대폰 기기 인증");
        } else {
          setSeqMemberPhoneAuth(seqMemberPhoneAuth);
          setTimer({ ...timer, timerStart: true, stop: false, refresh: refresh + 1 });
          dispatch({
            type: "UPDATE",
            data: { toast: true, toastText: "<span>인증번호가</span> 전송되었습니다." },
          });
          makeReadOnly();
        }
      }
    );
  };

  const clickCrtfcation = () => {
    const data: any = serializeObject({ selector: ".find-email-pop", element: null });
    if (!timerEnd) {
      if (!isEmpty(data.authNo)) {
        callApi(
          "/cmap1010/execAuthNumChkSignin",
          {
            seqMemberPhoneAuth: seqMemberPhoneAuth,
            authNo: data.authNo,
            mobile: data.mobile,
            name: data.name,
          },
          "POST"
        ).then((res) => {
          const msgVO = res.MsgVO;
          if (msgVO.msgCd !== "CMAP1010-00") {
            openAlert(msgVO.msgCtnt, "휴대폰 기기 인증");
            setDeviceCrtf(false);
          } else {
            openAlert("본인 인증에 성공하였습니다.", "휴대폰 기기 인증");
            setDeviceCrtf(true);
            setTimer({ ...timer, timerStart: true, timerEnd: false, stop: true });
            if (inputMobile.current) {
              inputMobile.current.readOnly = true;
            }
          }
        });
      } else {
        openAlert("인증 번호를 입력해주세요.", "휴대폰 기기 인증");
        setDeviceCrtf(false);
      }
    } else {
      sendCrtfcation();
      openAlert("인증 기간이 만료되었습니다. 인증번호를 다시 요청해 주세요.", "휴대폰 기기 인증");
      setDeviceCrtf(false);
      setTimer({ ...timer, timerStart: true, refresh: refresh + 1, timerEnd: false, stop: false });
    }
  };

  const clickPassword = () => {
    if (deviceCrtf) {
      const data: any = serializeObject({ selector: ".find-email-pop", element: null });
      callApi(
        "/cmap1010/viewEmail",
        { mobile: data.mobile, seqMemberPhoneAuth: seqMemberPhoneAuth, authNo: data.authNo },
        "GET"
      ).then((res1) => {
        if (res1.MsgVO.msgCd === "CMAP1010-00") {
          setEmailVO(res1.EmailVO);
          dispatch({
            type: "POP_UP_OPEN",
            id: "FIND_EMAIL_COMPLETE_POP",
            open: { findEmailCompletePop: true },
          });
        } else {
          openAlert(res1.MsgVO.msgCtnt, "이메일 아이디 찾기");
          //window.location.href="/home"
        }
      });
    }
  };

  return (
    <>
      <div className="find-email">
        <NameInput
          label="이름"
          name="name"
          placeholder="본인 이름"
          value={name}
          onChange={setName}
        />
        <InputBtn
          title="휴대전화 번호"
          name="mobile"
          type="tel"
          placeholder="- 없이 번호만 입력"
          onBlur={onblur}
          ref={inputMobile1}
        >
          {deviceCrtf ? (
            <div color="#fff" className="device-ctrfcation-crtf-btn disable">
              {timerStart && "다시요청"}
              {!timerStart && "인증요청"}
            </div>
          ) : (
            <div
              color="#fff"
              className="device-ctrfcation-crtf-btn active"
              onClick={sendCrtfcation}
            >
              {timerStart && "다시요청"}
              {!timerStart && "인증요청"}
            </div>
          )}
        </InputBtn>
        {!isEmpty(seqMemberPhoneAuth) && (
          <InputCertify
            label="인증 번호"
            name="authNo"
            type="tel"
            ref={inputMobile}
            number={true}
            succesText={succesText}
          >
            {timerStart && <Time end={setTimerEnd} refresh={refresh} stop={timer.stop} />}
            {deviceCrtf ? (
              <div className="device-ctrfcation-crtf-btn disable">인증완료</div>
            ) : (
              <div className="device-ctrfcation-crtf-btn active" onClick={clickCrtfcation}>
                확인
              </div>
            )}
          </InputCertify>
        )}
      </div>
      <div className="device-ctrfcation-footer find-password">
        <div className="btn" onClick={clickPassword} ref={btn}>
          <div>이메일 아이디 찾기</div>
        </div>
      </div>
      <FindEmailCompletePop d={emailVO} />
    </>
  );
};

export default FindEmailPopWrap;
